import { render, staticRenderFns } from "./detailDrFlagbanner.vue?vue&type=template&id=513202bc&scoped=true"
import script from "./detailDrFlagbanner.vue?vue&type=script&lang=js"
export * from "./detailDrFlagbanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513202bc",
  null
  
)

export default component.exports